import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/sections/mediakit/hand2-nobg.webp")